// src/components/SkeletonTable.tsx
import React from 'react';
import './SkeletonTable.css'; // CSS for skeleton loader styles

interface SkeletonTableProps {
  rows?: number; // Number of placeholder rows
  columns?: number; // Number of placeholder columns
}

const SkeletonTable: React.FC<SkeletonTableProps> = ({ rows = 5, columns = 3 }) => {
  return (
    <div className="skeleton-table">
      <table>
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, index) => (
              <th key={index}>
                <div className="skeleton skeleton-header"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex}>
                  <div className="skeleton skeleton-cell"></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SkeletonTable;